import gql from 'graphql-tag'

export const Q_GET_OFFENCES_PREVIEW = gql`
  query offencesPreview($startDate: String!, $endDate: String!, $currentTeam: String!) {
    getOffencesPreview(startDate: $startDate, endDate: $endDate, currentTeam: $currentTeam) {
      memberId
      fullName
      offences {
        effectiveDate
        offenseTypeId
        offenseType {
          name
        }
        offenseCount
        noticeLevel
        penalty {
          id
          penaltyDays
          noticeType {
            name
          }
        }
      }
    }
  }
`

export const Q_GET_NOTICE_TYPES = gql`
  query noticeTypes {
    noticeTypes {
      id
      name
      level
      expirationMonths
      createdAt
      updatedAt
    }
  }
`

export const Q_GET_OFFENSE_TYPES = gql`
  query offenseTypes {
    offenseTypes {
      id
      name
      description
      unit
      start
      end
      createdAt
      updatedAt
    }
  }
`

export const Q_GET_PENALTIES = gql`
  query penalties {
    penalties {
      id
      offenseTypeId
      offenseCount
      penaltyDays
      noticeTypeId
      createdAt
      updatedAt
      noticeType {
        id
        name
        level
      }
    }
  }
`

export const Q_GET_EXISTING_OFFENSES = gql`
  query offenses($where: ListWhere) {
    offenses(where: $where) {
      id
      memberId
      offenseTypeId
      offenseCount
      penaltyId
      penaltyDays
      noticeId
      noticeLevel
      prevOffenses
      attendances
      timeRecordId
      status
      effectiveDate
      expirationDate
      absentDays
      createdAt
      updatedAt
      notice {
        id
        body
      }
      member {
        id
        firstName
        fatherName
        fullName
        group
        currentTeam
      }
      offenseType {
        name
      }
      penalty {
        noticeType {
          id
          level
          name
        }
      }
    }
  }
`

export const M_CREATE_OFFENSE = gql`
  mutation createOffense($input: OffenseCreateInput!) {
    createOffense(input: $input) {
      id
      memberId
      offenseTypeId
      offenseCount
      penaltyId
      penaltyDays
      noticeId
      noticeLevel
      prevOffenses
      attendances
      timeRecordId
      status
      effectiveDate
      expirationDate
      absentDays
      createdAt
      updatedAt
    }
  }
`

export const M_DELETE_OFFENSE = gql`
  mutation deleteOffense($where: OffenseWhereInput!) {
    deleteOffense(where: $where)
  }
`
